import React from "react";
import ToggleableButton from "../../../../../../components/toggleableButton/toggleableButton";
import { useDispatch, useSelector } from "react-redux";
import { updateCompareDates } from "../redux/averageNumberOfVisitsPerClientSagas";

const CompareDates = () => {
  const { compare } = useSelector(state => state.averageNumberOfVisitsPerClient.selectedFilters);
  const dispatch = useDispatch();

  return (
    <ToggleableButton
      isActive={compare}
      isRadio={true}
      title="average-number-visits-per-client-compare-dates"
      onClick={data => dispatch(updateCompareDates(data))}
    />
  );
};

export default CompareDates;
